<template>
  <div>
    <div class="justify-content-center">
      <h3>გამარჯობა</h3>
      <p>{{ user.displayName }}</p>
      <p>{{ user.email }}</p>

      <button type="submit" class="btn btn-info mb-2" @click="logOut()">
        გამოსვლა
      </button>
    </div>

    <!-- table bootstrap -->
    <div class="m-2" style="padding-bottom: 10em">
      <table class="table table-hover table-bordered table-dark">
        <thead class="text-center">
          <tr>
            <th
              scope="col"
              v-for="(userTopic, index) in userTopics"
              :key="index"
            >
              {{ userTopic }}
            </th>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr v-for="(message, index) in userMessages" :key="index">
            <td>{{ index }}</td>
            <td>{{ message.dateCreated }}</td>
            <td>{{ message.name }}</td>
            <td>{{ message.famName }}</td>
            <td>{{ message.birthPlaceValue }}</td>
            <td>{{ message.birthDateValue }}</td>
            <td>{{ message.emailValue }}</td>
            <td>{{ message.telValue }}</td>
            <td>{{ message.donation }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import firebase from "firebase";
import "firebase/firestore";
import moment from "moment";

export default {
  data() {
    return {
      user: null,
      userTopics: [
        "#",
        "თარიღი",
        "სახელი",
        "გვარი",
        "დაბ. ადგილი",
        "დაბ. თარიღი",
        "ელ-ფოსტა",
        "ტელეფონი",
        "დონაცია",
      ],
      userMessages: [],
      userMessagesSorted: [],
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  },
  mounted() {
    this.fetchMessages();
  },

  methods: {
    async fetchMessages() {
      const db = firebase.firestore();
      const messageSnap = await db.collection("userMessages").get();
      this.userMessages = messageSnap.docs.map((p) => p.data());
      console.log(this.userMessages);
    },
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          firebase.auth().onAuthStateChanged(() => {
            this.$router.push("/login");
          });
        });
    },
  },
};
</script>
